// extracted by mini-css-extract-plugin
export default {"ActivateTrial":"ActivateTrial_ActivateTrial__wEZ3N"};